<script setup>
import { computed, inject } from 'vue'

const { isLoggedIn, application, pages } = inject('Shared')
const props = defineProps(['renovationPressure', 'height', 'width', 'blurred'])
const renovationPressureCss = computed(() => {
  const val = props.renovationPressure * 100
  let css = 'background-color: #DCE7F2; color: #007BFF;'
  switch (true) {
    case (val < 20): css = `background: ${pages.value.detailReport.potentialAnalysis.renovationPressureBackgroundLow}; color: ${pages.value.detailReport.potentialAnalysis.renovationPressureFontColorLow}`; break
    case (val < 50 && val >= 20): css = `background: ${pages.value.detailReport.potentialAnalysis.renovationPressureBackgroundMedium}; color: ${pages.value.detailReport.potentialAnalysis.renovationPressureFontColorMedium}`; break
    case (val >= 50): css = `background: ${pages.value.detailReport.potentialAnalysis.renovationPressureBackgroundHigh}; color: ${pages.value.detailReport.potentialAnalysis.renovationPressureFontColorHigh}`; break
  }
  css += `; width: ${val < 15 ? 15 : val}%`
  return css
})
</script>

<template lang='pug'>
.renovationPressureContainer(:class="blurred ? 'renovation-pressure--blur' : ''")
  .renovationPressureValueBG(:style="renovationPressureCss")
    .currentScore {{ Math.round(renovationPressure * 100) + '/' }}
    .maxScore 100
  .levelMarker(style='left: 0%')
    .label tief
  .levelMarker(style='left: 20%')
    .label mittel
  .levelMarker(style='left: 50%')
    .label hoch
</template>

<style scoped lang='sass'>
.renovation-pressure--blur
  filter: blur(15px)
  -webkit-filter: blur(15px)
.renovationPressureContainer
  width: v-bind(width)
  height: v-bind(height)
  left: 0px
  background: #DCE7F2
  border-radius: 4px
  position: relative
  .renovationPressureValueBG
    height: v-bind(height)
    left: 0px
    top: 0px
    position: absolute
    background: #F6D156
    border-radius: 4px
    width: v-bind(pressure)
    display: flex
    justify-content: center
    align-items: center
    .currentScore
      font-style: italic
      font-weight: bold
      font-size: 14px
      line-height: 130%
      margin-right: 5px
    .maxScore
      font-style: italic
      font-weight: 500
      font-size: 10px
      line-height: 130%
      margin-bottom: 6px
  .levelMarker
    position: absolute
    bottom: -6px
    height: 6px
    width: 1px
    background: #626C85
    .label
      margin-top: 5px
      margin-left: -10px
      font-weight: 600
      line-height: 130%
      color: #626C85
      @media screen and (min-width: 1024px)
        font-size: 10px
      @media screen and (max-width: 1023px)
        font-size: 8px
</style>
